import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../Store/actions';

const manageForm = (props) => {

	let classes = 'manage-form manage-form--small';

	return (
		<div className={classes}>

			<div className='manage-form__section'>

				<h5 className='manage-form__section__title'>Matter Options</h5>

				<ul className='iconlist'>
					<li className='iconlist__item' onClick={() => window.print()}><i className='fas fa-file-pdf'></i><label>Save as PDF</label></li>
					<li className='iconlist__item' onClick={() => window.print()}><i className='fas fa-print'></i><label>Print Matter</label></li>
				</ul>

			</div>

			<div className='manage-form__section'>

				<h5 className='manage-form__section__title'>Delete Matter</h5>

				<p className='manage-form__line'>By deleting the matter, no data is retained by <strong>Xpedite</strong>.</p>

				<p className='manage-form__line manage-form__line--small'>Tip: If you wish to retain a record, print a copy or save a PDF BEFORE you press DELETE MATTER</p>

				<p className='manage-form__line'>
					<button className='btn btn--key' onClick={() => props.rdxSetModal('delete_matter')}>Delete Matter</button>
				</p>

			</div>

		</div>
	);

}


const mapStateToProps = state => {
	return {
		matter: state.matter
	};
}

const mapDispatchToProps = dispatch => {
	return {
		rdxSetModal: (content) => dispatch(actions.setModal(content))
	};
}


export default connect(mapStateToProps,mapDispatchToProps)(manageForm);


// WEBPACK FOOTER //
// ./src/Blocks/ManageForm.js